import I18n from 'I18n';
import { createAction } from 'redux-actions';
const createInfoAction = (actionName, titleMessageKey, bodyMessageKey) => createAction(actionName, payload => payload, () => ({
  notification: {
    type: 'info',
    title: I18n.text(titleMessageKey),
    titleText: I18n.text(titleMessageKey),
    use: 'inline',
    message: I18n.text(bodyMessageKey)
  }
}));
export default createInfoAction;